let recaptcha = {
    init(context) {
      if($(context).hasClass('webform-submission-form')) {
        if (typeof grecaptcha != "undefined") {
          grecaptcha.render($('.g-recaptcha')[0]);
        }
      }
    }
}

export default recaptcha;
